import {
    DetailsList, DetailsListLayoutMode, DetailsRow, getId,
    IColumn,
    Icon, IDetailsRowProps, IDetailsRowStyles, Modal, SelectionMode
} from '@fluentui/react';
import { Authentication } from '../../common/views/Authentication';
import { StyleUtils } from '../../common/views/StyleUtils';
import { Utils } from '../../common/views/Utils';
import { WarehouseModel } from '../models/WarehouseModel';

type WarehouseViewProps = {
    onSelect: (warehouse: WarehouseModel) => void;
    onClose: () => void;
}

export default function WarehouseView({ onSelect, onClose }: WarehouseViewProps) {
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    const isMobile = window.innerWidth <= 500;
    const width2 = Utils.getColumnWidth(2);
    const width10 = Utils.getColumnWidth(10);

    const userRoles = Authentication.getUserRoles();

    const getColumns = (): IColumn[] => {
        let list: IColumn[] = [];

        let id: IColumn = {
            key: "id", name: "Id", fieldName: "id",
            minWidth: 50, maxWidth: 50, isResizable: true,
            onRender: (item: WarehouseModel) => {
                return <div>{item.id}</div>
            }
        };
        list.push(id);

        let name: IColumn = {
            key: "name", name: "Name", fieldName: "name",
            minWidth: 150, isResizable: true,
            onRender: (item: WarehouseModel) => {
                return <>{item.name}</>
            }
        };
        list.push(name);

        let color: IColumn = {
            key: "color", name: "Color", fieldName: "color",
            minWidth: 50, isResizable: false,
            onRender: (item: WarehouseModel) => {
                return <span className="dot" style={{ backgroundColor: item.color }}></span>
            }
        };
        list.push(color);

        return list;
    }

    const modalHeader = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row">
                <div className={width10}><b>Warehouse List</b></div>
                <div className={width2 + " right"}>
                    <Icon iconName="ChromeClose" className="pointer" onClick={onClose} />
                </div>
            </div>
        </div>;
    }

    const onRenderRow = (props: IDetailsRowProps | undefined): JSX.Element => {
        const customStyles: Partial<IDetailsRowStyles> = {};

        if (!props) return <></>;

        if (props.itemIndex % 2 === 0) {
            customStyles.root = { backgroundColor: "aliceblue" };
        }

        return <div className="pointer" onClick={() => onSelect(props.item)}>
            <DetailsRow
                key={"grid-row-" + props.itemIndex}
                {...props}
                styles={customStyles} />
        </div>;
    };

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={false}
            styles={StyleUtils.getModalWidthStyles(450)}
        >
            <div className="popup-header">
                {modalHeader()}
            </div>
            <div
                id={subtitleId}
                className={(isMobile ? "mobile-" : "") + "popup-body"}
                style={{ fontSize: "medium" }}
            >
                <DetailsList
                    items={userRoles.warehouses}
                    compact={false}
                    columns={getColumns()}
                    selectionMode={SelectionMode.none}
                    layoutMode={DetailsListLayoutMode.justified}
                    isHeaderVisible={true}
                    onRenderRow={onRenderRow}
                />
            </div>
        </Modal>
    </>;
}